<!--
 * @Description: 信用与风险信息
 * @Author: LiangYiNing
 * @Date: 2021-12-22 11:15:10
 * @LastEditTime: 2022-06-13 16:16:15
 * @LastEditors: LiangYiNing
-->
<template>
  <section class="edit-wrapper">
    <div class="edit-wrapper__body">
      <div class="detailInfo-content">
        <!-- 基本信息 start -->
        <div class="baseInfo-box">
          <div class="edit-title">客户信用信息</div>
          <el-form
            ref="corpBaseForm"
            label-width="140px"
            label-position="right"
            disabled
            :inline="true"
            :model="creditMsg"
            class="editForm"
          >
            <el-form-item label="信用等级" prop="creditLevelName">
              <el-input
                v-model="creditMsg.creditLevelName"
                placeholder="暂无记录"
              ></el-input>
            </el-form-item>

            <el-form-item label="信用期(单位/天)" prop="creditPeriod">
              <el-input
                v-model="creditMsg.creditPeriod"
                placeholder="暂无记录"
              ></el-input>
            </el-form-item>

            <el-form-item label="信用额度(单位/万元)" prop="lineOfCredit">
              <el-input
                v-model="creditMsg.lineOfCredit"
                placeholder="暂无记录"
              ></el-input>
            </el-form-item>
            <el-form-item label="资产负债率" prop="debt">
              <el-input
                v-model="creditMsg.debt"
                placeholder="暂无记录"
              ></el-input>
            </el-form-item>
            <el-form-item label="纳税人等级" prop="taxpayerLevel">
              <el-input
                v-model="creditMsg.taxpayerLevel"
                placeholder="暂无记录"
              ></el-input>
            </el-form-item>
            <el-form-item label="违规信息" prop="violateInfo">
              <el-input
                v-model="creditMsg.violateInfo"
                placeholder="暂无记录"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 基本信息 end -->
        <!-- 信用信息   start -->
        <!-- <div class="baseInfo-box">
          <div class="edit-title">风险信息</div>
          <el-form
            class="editForm"
            label-width="140px"
            label-position="right"
            :inline="true"
            :model="creditMsg"
          >
            <el-form-item label="风险等级" prop="creditLevel">
              <el-input v-model="creditMsg.creditLevel"></el-input>
            </el-form-item>

            <el-form-item label="自身风险" prop="creditPeriod">
              <el-input v-model="corpBase.creditPeriod"></el-input>
            </el-form-item>

            <el-form-item label="周边风险" prop="lineOfCredit">
              <el-input v-model="corpBase.lineOfCredit"></el-input>
            </el-form-item>
            <el-form-item label="历史风险" prop="debt">
              <el-input v-model="corpBase.debt"></el-input>
            </el-form-item>
            <el-form-item label="预警提醒" prop="debt">
              <el-input v-model="corpBase.debt"></el-input>
            </el-form-item>
          </el-form>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
import base from "@/mixins/base";

export default {
  name: "riskInfo",
  components: {},
  mixins: [base],
  data() {
    return {};
  },
  props: {
    //客户基础信息
    creditMsg: {
      type: Object,
      default() {
        return {
          creditLevel: "", //信用等级
          creditPeriod: "", //信用期
          lineOfCredit: "", //信用额度
          debt: "", //资产负债率
          taxpayerLevel: "", //纳税人等级
          violateInfo: "" //违规信息
        };
      }
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="scss" scoped>
//新增页面form表单样式
.edit-wrapper__body {
  .el-form {
    .el-input {
      width: 250px;
    }
    .el-select {
      width: 250px;
    }
    .el-textarea {
      width: 250px;
    }
  }
}
.address-box {
  display: flex;
  align-items: center;
}
.baseInfo-box {
  .el-input {
    width: 220px;
  }
  .el-select {
    width: 220px;
  }
}
</style>
